module.exports = __webpack_public_path__ + "assets/img/1425.458a9000.png";